import { globalModule } from "../service-provider/GlobalModule";
import { registerGlobalService } from "../service-provider/ServiceRegistry";

export interface LocalStorage {
  setItem(key: string, value: string): void;
  getItem(key: string): string;
}
export class LocalStorageService implements LocalStorage {
  setItem = (key: string, value: any) => {
    window.localStorage.setItem(key, JSON.stringify(value));
  };

  getItem = (key: string) => {
    const item = window.localStorage.getItem(key);
    return item ? JSON.parse(item) : item;
  };
}

export const appLocalStorage = new LocalStorageService();
globalModule.appLocalStorage = appLocalStorage;
export default registerGlobalService(appLocalStorage as LocalStorage);
